'use client';

import { c as _c } from "react/compiler-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComments } from '@awesome.me/kit-94e593bf23/icons/sharp/thin';
import { useHelpWidget } from '@/app/_plugins/HelpWidget/HelpWidgetContext';
const FloatingChatIcon = () => {
  const $ = _c(9);
  const {
    openWidget,
    isOpen,
    aiMessages
  } = useHelpWidget();
  let t0;
  if ($[0] !== openWidget) {
    t0 = () => {
      openWidget("ai_assistant");
    };
    $[0] = openWidget;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleClick = t0;
  if (isOpen) {
    return null;
  }
  const hasConversation = aiMessages && aiMessages.length > 1;
  const t1 = hasConversation ? "Continue conversation with AI shopping assistant" : "Open AI shopping assistant";
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <FontAwesomeIcon icon={faComments} className="text-ink-gray-bg text-2xl" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== hasConversation) {
    t3 = hasConversation && <span className="absolute top-2 right-2 w-2 h-2 bg-primary rounded-full" aria-hidden="true" />;
    $[3] = hasConversation;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== handleClick || $[6] !== t1 || $[7] !== t3) {
    t4 = <button onClick={handleClick} className="fixed right-0 bottom-8 w-[2rem] bg-gray-7 rounded-l-md shadow-[-4px_4px_8px_-2px_rgba(0,0,0,0.15)] flex flex-col items-center justify-center py-3 z-[999] transition-all duration-300" aria-label={t1}>{t2}{t3}</button>;
    $[5] = handleClick;
    $[6] = t1;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
export default FloatingChatIcon;